import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: "1",
    width: "100%",
  },
  logo: {
    height: "50px",
    width: "50px",
  },
  bar: {
    borderRadius: "5px",
    backgroundColor: "#212529",
  },
}));
